(() => {
'use strict';
if (window.__ravinDualPagesBooted) return;
window.__ravinDualPagesBooted = true;
const controllers = new WeakMap();
const clamp = value => Math.max(0, Math.min(1, value));
const smooth = (a, b, value) => {
  const t = clamp((value - a) / (b - a));
  return t * t * (3 - 2 * t);
};
function init(root) {
  if (!root || controllers.has(root)) return;
  const find = key => root.querySelector('[data-rod="' + key + '"]');
  const track = find('track');
  if (!track) return;
  const items = {
    bg: find('bg'), blackout: find('blackout'), shadow: find('shadow'),
    hero: find('hero'), cue: find('cue'), heroIndex: find('heroIndex'),
    fitCopy: find('fitCopy'), portrait: find('portrait'), fitItems: find('fitItems'),
    phase: find('phase'), wipe: find('wipe'), count: find('count'), fill: find('fill')
  };
  if (Object.values(items).some(item => !item)) return;
  const abort = new AbortController();
  const mobile = matchMedia('(max-width:700px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const explore = find('explore');
  const logo = root.querySelector('[data-rdp-logo]');
  const logoAnchor = root.querySelector('[data-rdp-logo-anchor]');
  const stage = root.querySelector('.rod-stage');
  const headerLogo = document.querySelector('.section-header .header__heading-logo-wrapper');
  const headerBar = document.querySelector('.section-header .header');
  const logoEnabled = root.dataset.rdpLogoEnabled === 'true' && logo && logoAnchor && stage && headerLogo && headerBar;
  const editorMode = root.dataset.rdpEditor === 'true' || Boolean(window.Shopify && window.Shopify.designMode);

  let target = 0;
  let current = 0;
  let frameId = 0;
  const maxScroll = () => Math.max(1, track.offsetHeight - innerHeight);
  const startScroll = () => track.getBoundingClientRect().top + scrollY;
  const progress = () => clamp(-track.getBoundingClientRect().top / maxScroll());
  const writeHeader = (p) => {
    const viewport = track.getBoundingClientRect();
    if (viewport.bottom <= 0 || viewport.top >= innerHeight) return;
    const alpha = smooth(.14, .33, p);
    document.body.style.setProperty('--rod-header-opacity', alpha.toFixed(3));
    document.body.style.setProperty('--rod-header-ink', alpha > .50 ? '#111111' : '#ffffff');
    document.body.style.setProperty('--rod-logo-invert', alpha > .50 ? '0' : '1');
  };
  const animateLogo = p => {
    if (!logoEnabled) return;
    if (editorMode) {
      logo.dataset.rdpLogoReady = 'true';
      document.body.style.setProperty('--rdp-header-logo-opacity','1');
      return;
    }
    const stageRect = stage.getBoundingClientRect();
    const anchorRect = logoAnchor.getBoundingClientRect();
    const headerRect = headerLogo.getBoundingClientRect();
    const flight = reduced.matches ? (p >= .20 ? 1 : 0) : smooth(.005,.30,p);
    const startWidth = Math.max(1,anchorRect.width);
    const targetWidth = Math.max(1,headerRect.width);
    const startX = anchorRect.left-stageRect.left;
    const startY = anchorRect.top-stageRect.top;
    const endX = headerRect.left+(headerRect.width-targetWidth)/2-stageRect.left;
    const endY = headerRect.top+headerRect.height/2-targetWidth/8-stageRect.top;
    const x = startX+(endX-startX)*flight;
    const y = startY+(endY-startY)*flight;
    const scale = (startWidth+(targetWidth-startWidth)*flight)/startWidth;
    const nativeOpacity = reduced.matches ? (p >= .20 ? 1 : 0) : smooth(.25,.33,p);
    const floatOpacity = reduced.matches ? (p >= .20 ? 0 : 1) : 1-smooth(.24,.33,p);
    logo.style.left = '0';
    logo.style.top = '0';
    logo.style.width = startWidth+'px';
    logo.style.transform = 'translate3d('+x.toFixed(2)+'px,'+y.toFixed(2)+'px,0) scale('+scale.toFixed(4)+')';
    logo.style.filter = 'brightness('+(1-smooth(.18,.31,p)).toFixed(3)+')';
    logo.style.setProperty('--rdp-floating-opacity',floatOpacity.toFixed(3));
    logo.style.pointerEvents = floatOpacity > .65 ? 'auto' : 'none';
    logo.dataset.rdpLogoReady = 'true';
    document.body.style.setProperty('--rdp-header-logo-opacity',nativeOpacity.toFixed(3));
  };

  function render(p) {
    const transit = smooth(.10, .52, p);
    const appear = smooth(.27, .52, p);
    const details = smooth(.53, .77, p);
    const fade = smooth(.06, .29, p);
    const wipe = smooth(.94, 1, p);
    const isMobile = mobile.matches;
    const isArabic = document.documentElement.lang.toLowerCase().startsWith('ar');
    items.bg.style.transform = 'translate3d(' + (-3 * transit) + '%,0,0) scale(' + (1.02 + .24 * transit) + ')';
    items.bg.style.filter = 'brightness(' + (1 - .50 * transit) + ') blur(' + (2 * details) + 'px)';
    items.blackout.style.opacity = String(.97 * transit);
    items.hero.style.opacity = String(1 - fade);
    items.hero.style.transform = isMobile
      ? 'translate3d(' + ((isArabic ? 20 : -20) * fade) + 'px,' + (-28 * fade) + 'px,0)'
      : 'translate3d(' + ((isArabic ? 55 : -55) * fade) + 'px,calc(-40% - ' + (27 * fade) + 'px),0)';
    items.cue.style.opacity = items.heroIndex.style.opacity = String(1 - fade);
    items.shadow.style.opacity = String(.75 * appear);
    items.shadow.style.transform = 'translate(-50%,' + (-40 - 13 * transit) + '%)';
    items.fitCopy.style.opacity = String(appear * (1 - .2 * wipe));
    items.fitCopy.style.transform = isMobile
      ? 'translateY(' + (-16 * (1 - appear)) + 'px)'
      : 'translate(' + ((isArabic ? 25 : -25) * (1 - appear)) + 'px,-50%)';
    items.fitCopy.style.pointerEvents = p > .35 ? 'auto' : 'none';
    items.portrait.style.opacity = String(appear * (1 - .12 * wipe));
    items.portrait.style.transform = 'translate(-50%,' + (-43 - 7 * appear) + '%) perspective(1300px) rotateY(' + (-18 + 18 * appear) + 'deg) rotateZ(' + (-6 + 5.5 * appear) + 'deg) scale(' + (.73 + .27 * appear) + ')';
    items.fitItems.style.opacity = String(details * (1 - .1 * wipe));
    items.fitItems.style.transform = isMobile
      ? 'translateY(' + (24 * (1 - details)) + 'px)'
      : 'translate(' + ((isArabic ? -30 : 30) * (1 - details)) + 'px,-32%)';
    items.fitItems.style.pointerEvents = p > .58 ? 'auto' : 'none';
    items.phase.style.opacity = String(smooth(.63, .83, p) * (1 - wipe));
    items.wipe.style.height = (100 * wipe) + '%';
    items.count.textContent = p > .51 ? '02' : '01';
    items.fill.style.transform = 'scaleX(' + p + ')';
    const fitLink = items.fitCopy.querySelector('a');
    if (fitLink) fitLink.tabIndex = p > .35 && !isMobile ? 0 : -1;
    items.fitItems.querySelectorAll('a').forEach(link => { link.tabIndex = p > .58 ? 0 : -1; });
    if (explore) explore.tabIndex = p < .27 ? 0 : -1;
    writeHeader(p);
    animateLogo(p);
  }
  function tick() {
    frameId = 0;
    current = reduced.matches ? target : current + (target - current) * .095;
    if (Math.abs(target - current) < .0002) current = target;
    render(current);
    if (Math.abs(target - current) > .0002) frameId = requestAnimationFrame(tick);
  }
  function update() {
    target = progress();
    if (!frameId) frameId = requestAnimationFrame(tick);
  }
  window.addEventListener('scroll', update, { passive: true, signal: abort.signal });
  window.addEventListener('resize', update, { passive: true, signal: abort.signal });
  const choose = find('choose');
  const choiceDialog = root.querySelector('[data-rod-chooser]');
  const choiceGrid = choiceDialog?.querySelector('[data-rod-chooser-grid]');
  const choiceClose = choiceDialog?.querySelector('[data-rod-chooser-close]');
  let choiceOpener = null;
  const goToChoices = event => {
    event.preventDefault();
    window.scrollTo({
      top:startScroll() + maxScroll() * .81,
      behavior:reduced.matches?'auto':'smooth'
    });
  };
  // The second-scene CTA must do more than scroll to the cards already on
  // screen. Open a real, accessible chooser using the two configured links.
  const openChoices = event => {
    if(!choiceDialog || !choiceGrid || typeof choiceDialog.showModal !== 'function'){
      // Preserve native #destinations link behavior on legacy browsers.
      return;
    }
    const targets=Array.from(items.fitItems.querySelectorAll('a.rod-mini-item[href]'));
    if(targets.length!==2)return;
    event.preventDefault();
    choiceOpener=choose;
    choiceGrid.replaceChildren(...targets.map(link=>{
      const clone=link.cloneNode(true);
      clone.removeAttribute('tabindex');
      clone.classList.remove('is-active');
      return clone;
    }));
    try {
      choiceDialog.showModal();
      choiceClose?.focus({preventScroll:true});
    } catch(e) {
      // If the dialog cannot be opened, the in-scene destination cards still
      // provide direct Men / Women links, without a false success indication.
      window.scrollTo({top:startScroll()+maxScroll()*.81,behavior:'smooth'});
    }
  };
  explore?.addEventListener('click',goToChoices,{signal:abort.signal});
  choose?.addEventListener('click',openChoices,{signal:abort.signal});
  choiceClose?.addEventListener('click',()=>choiceDialog.close(),{signal:abort.signal});
  choiceDialog?.addEventListener('click',event=>{
    if(event.target===choiceDialog)choiceDialog.close();
  },{signal:abort.signal});
  choiceDialog?.addEventListener('close',()=>{
    if(choiceOpener?.isConnected)choiceOpener.focus({preventScroll:true});
    choiceOpener=null;
  },{signal:abort.signal});
  const destroy = () => {
    abort.abort();
    if(choiceDialog?.open)choiceDialog.close();
    if (frameId) cancelAnimationFrame(frameId);
    document.body.style.removeProperty('--rdp-header-logo-opacity');
    controllers.delete(root);
    if (!document.querySelector('[data-ravin-off-duty]')) {
      document.body.style.removeProperty('--rod-header-opacity');
      document.body.style.removeProperty('--rod-header-ink');
      document.body.style.removeProperty('--rod-logo-invert');
    }
  };
  controllers.set(root, destroy);
  target = current = progress();
  render(current);
}
function boot() {
  document.querySelectorAll('[data-ravin-dual-pages]').forEach(init);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
else boot();
document.addEventListener('shopify:section:load', boot);
document.addEventListener('shopify:section:unload', event => {
  const root = event.target && (event.target.matches?.('[data-ravin-dual-pages]') ? event.target : event.target.querySelector?.('[data-ravin-dual-pages]'));
  if (root && controllers.has(root)) controllers.get(root)();
});
})();